export default __webpack_public_path__ + "static/media/50.1be6c57e.png";